import { styled, TextField } from "@mui/material";
import { useTheme } from "../../contexts/ThemeContext";

const StyledTextField = styled(TextField)(({ theme, customtheme }) => ({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: customtheme.text.primary, // Updated border color
    },
    "&:hover fieldset": {
      borderColor: customtheme.text.primary, // Updated hover border color
    },
    "&.Mui-focused fieldset": {
      borderColor: customtheme.text.primary, // Updated focused border color
    },
  },
  "& .MuiInputLabel-root": {
    color: customtheme.text.primary, // Updated label color
    fontFamily: customtheme.fontFamily,
    "&.Mui-focused": {
      color: customtheme.text.primary, // Updated focused label color
    },
  },
  "& .MuiOutlinedInput-input": {
    fontFamily: customtheme.fontFamily,
    color: customtheme.text.primary, // Updated input text color
  },
  "& .MuiInputLabel-outlined.Mui-error": {
    color: customtheme.accent.error,
  },
  "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
    borderColor: customtheme.accent.error,
  },
}));

const CustomInput = ({ type, isError, ...props }) => {
  const { theme } = useTheme();

  return (
    <StyledTextField
      {...props}
      label={isError ? `${props.label} *` : props.label}
      type={type}
      slotProps={{
        input: props.InputProps,
      }}
      error={isError}
      customtheme={theme}
    />
  );
};

export default CustomInput;